export default "__VITE_ASSET__Cw5yOb6m__"